module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"placeholder":"Enter message*","emptyError":"Please enter a message","overCharacterLimitError":"Using merge fields may exceed character limit"}}')
  delete Component.options._Ctor
}
